import React from "react";

export const QuickSearchArticleItem = ({ image, articleNumber, seriesList }) => {
    return (
        <li className="item article-result-item">
            {seriesList &&
                seriesList.map((item, i) => {
                    return (
                        <a href={item.articleUrl} key={i}>
                            <img src={i18n.CdnHostName + image + "?width=30"} alt={articleNumber} />
                            <span>{articleNumber}</span>
                            <span>{item.seriesName}</span>
                        </a>
                    );
                })}
        </li>
    );
};

export const QuickSearchArticleItemLarge = ({ image, name, usp, url }) => {
    return (
        <li className="item product-result-item">
            <a href={url}>
                <img src={i18n.CdnHostName + image + "?width=50"} alt={name} />
                <div>
                    <h5>{name}</h5>
                    <span>{usp}</span>
                </div>
            </a>
        </li>
    );
};
